module.exports = __webpack_public_path__ + "img/do.1792f382.jpg";